import React, { useState } from "react";
import { Link } from "react-router-dom";
import GenericModal from "../../_generic_modal";
import { useTranslation } from 'react-i18next';

const ChanceBlock = ({ user }) => {

  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false)

  const cards = Object.values(user.cartes).filter(value => value === true).length
  let bonus = 0
  let multiplicateur = 1

  if (cards >= 3 && cards < 6)
    bonus = 1
  else if (cards >= 6 && cards < 8)
    bonus = 2
  else if (cards >= 8) {
    bonus = 2
    multiplicateur = 2
  }

  const chances = (cards + bonus) * multiplicateur

  return (
    <>
      <div id={"chanceBlock"}>
      <div>
        {chances > 1
          ? <>{t("chances_vous_avez")} <span>{chances}</span> {t("chances_chances")}</>
          : <>{t("chances_vous_avez")} <span>{chances}</span> {t("chances_chance")}</>
        }
      </div>
        <Link to={"#"} className={"cta dark"} onClick={() => setShowModal(true)}>{t("chances_en_savoir_plus")}</Link>
      </div>
      <GenericModal id={"en_savoir_plus_modal"} show={showModal} handleClose={() => setShowModal(false)}></GenericModal>
    </>
  )
}

export default ChanceBlock
